<template>
    <form class="login100-form flex-sb flex-w mt-4">
        <span class="login100-form-title pb-3">
            Đăng ký
        </span>

        <div class="pb-3 w-100">
            <span v-if="error_server" class="error-message">{{error_server}}</span>
        </div>

        <span class="txt1 pb-2">Số điện thoại</span>
        <div class="mb-3 w-100">
            <div class="wrap-input100">
                <input class="input100"
                       type="number"
                       inputmode="numeric"
                       pattern="[0-9]*"
                       v-model.trim="form.phone_number"
                       name="phone_number">
                <span class="focus-input100"></span>
            </div>
            <div v-if="$v.form.phone_number.$error">
                <span class="error-message" v-if="!$v.form.phone_number.required">Số điện thoại không được để trống</span>
                <span class="error-message" v-if="!$v.form.phone_number.minLength">Số điện thoại phải có ít nhất 10 số</span>
            </div>
        </div>


        <span class="txt1 pb-2">Họ tên</span>
        <div class="mb-3 w-100">
            <div class="wrap-input100">
                <input class="input100"
                       type="text"
                       v-model.trim="form.name"
                       name="name">
                <span class="focus-input100"></span>
            </div>
            <div v-if="$v.form.name.$error">
                <span class="error-message" v-if="!$v.form.name.required">Họ tên không được để trống</span>
                <span class="error-message" v-if="!$v.form.name.minLength">Họ tên phải có ít nhất 4 kí tự</span>
            </div>
        </div>

        <span class="txt1 pb-2">Mật khẩu</span>
        <div class="mb-4 w-100">
            <div class="wrap-input100">
                <input class="input100"
                       type="password"
                       v-model.trim="form.password"
                       name="pass">
                <span class="focus-input100"></span>
            </div>
            <div v-if="$v.form.password.$error">
                <span class="error-message" v-if="!$v.form.password.required">Mật khẩu không được để trống</span>
                <span class="error-message" v-if="!$v.form.password.minLength">Mật khẩu phải có ít nhất 4 kí tự</span>
            </div>
        </div>

        <div class="container-login100-form-btn">
            <button class="login100-form-btn" type="button" @click="submit" :disabled="isSubmitting">
                Đăng ký
            </button>
        </div>

    </form>
</template>

<script>
    import {required, minLength} from 'vuelidate/lib/validators'
    import {AUTH_REGISTER} from "../../../store/actions/Auth";
    import {MixinHelper} from "../../shared/services";
    export default {
        name: "Register",
        mixins: [MixinHelper],
        data() {
            return {
                form: {
                    phone_number: '',
                    name: '',
                    password: ''
                },
                error_server: null,
                isSubmitting: false
            }
        },
        validations: {
            form: {
                phone_number: {
                    required,
                    minLength: minLength(10)
                },
                name: {
                    required,
                    minLength: minLength(4)
                },
                password: {
                    required,
                    minLength: minLength(4)
                }
            }
        },
        methods: {
            submit() {
                this.isSubmitting = true;
                const self = this;
                this.$v.form.$touch();
                if (this.$v.form.$pending || this.$v.form.$error) {
                    return;
                }
                this.$store.dispatch(AUTH_REGISTER, this.form)
                    .then(resp => {
                        this.$modalAuth.hide();
                    })
                    .catch(err => {
                        this.error_server = this.getProp(err, 'response.data.message', 'Thất bại vì lí do bất ngờ');
                    })
                    .finally(() => {
                        self.isSubmitting = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>
